// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { modifyInsurance } = require('./insuranceRequestRelatedModify');

// @ constants

const {
    INSURANCE_REQUEST_RELATED_WIZARD_CLEAR,
    INSURANCE_REQUEST_RELATED_RNC_WIZARD_CLEAR
} = require('../../insuranceConstants/actionTypes');

const clearWizardRequest = () => ({
    type: INSURANCE_REQUEST_RELATED_WIZARD_CLEAR
});

const clearWizardRncRequest = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_WIZARD_CLEAR
});

const clearRequest = (insuranceIdDraft, isRnc = false) => dispatch => {
    const clearRequest = isRnc ? clearWizardRncRequest() : clearWizardRequest();
    dispatch(clearRequest);
    dispatch(modifyInsurance(false));
    if (insuranceIdDraft) {
        return APIPost(
            dispatch,
            apiURLBuilder.getURL('insuranceRequestRelatedCancelDraft', { id: insuranceIdDraft })
        )
    }
}


module.exports = {
    clearRequest
};
